export const auth = {
  loginTitle: 'Sign in',
  loginSubtitle: 'Sign in to your account to continue.',
  tagline: 'Your backoffice platform.',
  email: 'Email',
  password: 'Password',
  submit: 'Sign in',
  passwordShow: 'Show password',
  passwordHide: 'Hide password',
  azureSignIn: 'Sign in with Microsoft',
  orContinueWith: 'or continue with email',
  invalidCredentials: 'Invalid email or password.',
  azureCallbackPending: 'Completing Microsoft sign-in...',
  azureCallbackFailed: 'Could not complete sign-in. Please try again.',
  logout: 'Sign out',
  validation: {
    invalidEmail: 'Invalid email address',
    passwordTooShort: 'Password must be at least 8 characters',
  },
} as const;
